import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface TimelineItem {
  readonly description?: ReactNode;
  readonly id: string;
  readonly timestamp: ReactNode;
  readonly title: ReactNode;
}

export function Timeline({ items }: { readonly items: readonly TimelineItem[] }) {
  return (
    <Stack component="ol" spacing={2} sx={{ listStyle: 'none', m: 0, p: 0 }}>
      {items.map((item) => (
        <Stack
          component="li"
          key={item.id}
          spacing={0.5}
          sx={{ borderLeft: 2, borderColor: 'divider', pl: 2 }}
        >
          <Typography sx={{ fontWeight: 700 }}>{item.title}</Typography>
          <Typography color="text.secondary" variant="body2">
            {item.timestamp}
          </Typography>
          {item.description === undefined ? null : (
            <Typography variant="body2">{item.description}</Typography>
          )}
        </Stack>
      ))}
    </Stack>
  );
}
